import React, { useRef, useState } from 'react';
import HTMLFlipBook from 'react-pageflip';import { Link } from "react-router-dom";
import p1 from "../../assets/P-1.jpg";
import p2 from "../../assets/P-2.jpg";
import p3 from "../../assets/P-3.jpg";
import p4 from "../../assets/P-4.jpg";
import trust from "../../assets/tr.svg"

import Lottie from "react-lottie-player";
import swipe from "../../assets/swipe.json"
const Flipbook = () => {
  const flipBookRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(0);

  const totalPages = 3; // Total number of pages

  const goToNextPage = () => {
    if (flipBookRef.current && currentPage < totalPages - 1) {
      flipBookRef.current.pageFlip().flipNext();
      setCurrentPage(prevPage => prevPage + 1);
    }
  };

  const goToPrevPage = () => {
    if (flipBookRef.current && currentPage > 0) {
      flipBookRef.current.pageFlip().flipPrev();
      setCurrentPage(prevPage => prevPage - 1);
    }
  };

  return (
        <>
           <div className='desPage'>
 <div className="flipbook-container">
     
     <HTMLFlipBook 
       ref={flipBookRef}
       className="flipbook"
       width={450} 
       height={650}
       showCover={false}
     >
       <div className="singlePage ">
               <div className='contentPage'>
               <h2>A Themed Booklet  Compiled by Katharine!</h2>
         <p>The booklet that Katharine writes from Dingle Ireland for our treasured community is one of our members favorite surprise from each month’s MyIrelandBox.</p>
         <h3>Message from Katharine:</h3>
         <p>Our members all know how much I love to write this them. I have stacks of books on my desk here about Ireland and what a great excuse to accumulate them for my research.   The booklet also includes personal stories, recipies that have been transferred to us throughout the generations, history about our Emerald Isle and more!</p>
         <h3>Comment from member: PattI l. </h3>
         <p>The monthly booklet is such a treat. I have learned so much about the ancestral home of my maternal grandparents. I think My Ireland Box has enriched my life and helped me to discover my Irish soul.</p>
        <div className='pageTrust'>
        <p>Verified review from</p>
        <img src={trust}/>
        </div>

        <div className="page-animation">
             <Lottie
               loop
               animationData={swipe}
               play
               style={{ width: 150, height: 150 }}
             />
           </div>
         
               </div>
       </div>
       <div className="page">
         <img src={p1} alt="Page 2" />
       </div>
       <div className="page">
         <img src={p2} alt="Page 3" />
       </div>
       <div className="page">
         <img src={p3} alt="Page 4" />
       </div>
       <div className="page">
         <Link to="/form">
           <img src={p4} alt="Page 5" />
         </Link>
       </div>
       <div className="singlePage"></div>
     </HTMLFlipBook>
     {/* <div className="controls">
       <button onClick={goToPrevPage}>Prev</button>

       <button onClick={goToNextPage}>Next</button>
     </div> */}
     <div className='swipe-controls'>
       <p>Swipe The Booklet</p>
       <p>To Get a Preview</p>
     </div>
   </div>
      </div>
      <div className='mobPage'>
         <div className="flipbook-container">
     
     <HTMLFlipBook 
       ref={flipBookRef}
       className="flipbook"
       width={300} 
       height={500}
       showCover={false}
     >
     
       <div className="page">
         <img src={p1} alt="Page 2" />
       </div>
       <div className="page">
         <img src={p2} alt="Page 3" />
       </div>
       <div className="page">
         <img src={p3} alt="Page 4" />
       </div>
       <div className="page">
         <Link to="/form">
           <img src={p4} alt="Page 5" />
         </Link>
       </div>
    
     </HTMLFlipBook>
   
     <div className='swipe-controls'>
       <p>Swipe The Booklet</p>
       <p>To Get a Preview</p>
     </div>
   </div>
      </div></>
  );
};

export default Flipbook;